import { render, staticRenderFns } from "./GoodsItem.vue?vue&type=template&id=3a7385f0&scoped=true&"
import script from "./GoodsItem.vue?vue&type=script&lang=js&"
export * from "./GoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./GoodsItem.vue?vue&type=style&index=0&id=3a7385f0&lang=less&"
import style1 from "./GoodsItem.vue?vue&type=style&index=1&id=3a7385f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7385f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a7385f0')) {
      api.createRecord('3a7385f0', component.options)
    } else {
      api.reload('3a7385f0', component.options)
    }
    module.hot.accept("./GoodsItem.vue?vue&type=template&id=3a7385f0&scoped=true&", function () {
      api.rerender('3a7385f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Goods/GoodsItem.vue"
export default component.exports